const getInterest = (onSuccess, onFailure) => {
  fetch("https://api.clubfilacred.com.ar/loan/rates").then((response) => {
    if (response.ok) response.json().then(onSuccess);
    else onFailure();
  });
};

const api = {
  getInterest,
};

export default api;
